export const ProfileTranslations = {
  en: {
    profile: {
      title: "My Profile",
      fullName: "Full Name",
      email: "Email",
      company: "Company",
      phone: "Phone Number",
      country: "Country",
      changePassword: "Change Password",
    },
  },
  es: {
    profile: {
      title: "Mi perfil",
      fullName: "Nombre completo",
      email: "Correo electrónico",
      company: "Empresa",
      phone: "Teléfono",
      country: "País",
      changePassword: "Cambiar contraseña",
    },
  },
};
